import { IFormViewForm } from 'components/FormView';

const ProductReceiptLineDetailsForm: IFormViewForm = {
    id: 'ProductReceiptLineDetailsForm',
    layout: {
        rows: 1,
        columns: 2
    },
    fields: [
        {
            id: 1,
            position: {
                row: 1,
                col: 1
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                label: '',
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Product',
                        name: 'ProductIdDisplay',
                        placeholder: '',
                        size: 'medium',
                        required: false,
                        readOnly: true,
                        disabled: true
                    }
                },
                {
                    id: 2,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'Description',
                        placeholder: '',
                        size: 'large',
                        required: false,
                        inputProps: {
                            maxLength: 40
                        }
                    }
                },
                {
                    id: 3,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Quantity',
                        name: 'Quantity',
                        size: 'small',
                        decimalSeparator: true,
                        alignment: 'right',
                        placeholder: '0.00',
                        decimalPlaces: 2
                    }
                },
                {
                    id: 4,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Buy unit',
                        name: 'BuyUnit',
                        placeholder: '',
                        size: 'small',
                        lookupName: 'UnitCode',
                    }
                },
                {
                    id: 5,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Unit conversion factor',
                        name: 'UnitConversion',
                        size: 'small',
                        decimalSeparator: true,
                        alignment: 'right',
                        placeholder: '0.0000',
                        decimalPlaces: 4
                    }
                },
                {
                    id: 6,
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Buy price',
                        alignment: 'right',
                        name: 'BuyPrice',
                        decimalPlaces: 4,
                        placeholder: '0.0000',
                        size: 'small',
                        decimalSeparator: true,
                    }
                },
                {
                    id: 7,
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Extended',
                        name: 'Extended',
                        alignment: 'right',
                        size: 'small',
                        placeholder: '0.00',
                        decimalSeparator: true,
                        decimalPlaces: 2,
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 1,
                col: 2
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Tax',
                        name: 'Tax',
                        type: 'number',
                        size: 'small',
                        placeholder: '0.00',
                        decimalSeparator: true,
                        decimalPlaces: 2,
                    }
                },
                {
                    id: 2,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'SubTotal',
                        label: 'Sub total',
                        type: 'number',
                        decimalSeparator: true,
                        size: 'small',
                        placeholder: '0.00',
                        decimalPlaces: 2,
                    }
                },
                {
                    id: 3,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'OverCharge',
                        label: 'Overcharge',
                        placeholder: '0.00',
                        type: 'number',
                        decimalSeparator: true,
                        size: 'small',
                        decimalPlaces: 2,
                    }
                },
                {
                    id: 4,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'InvoiceLineTotal',
                        label: 'Invoice line total',
                        placeholder: '0.00',
                        type: 'number',
                        decimalSeparator: true,
                        size: 'small',
                        decimalPlaces: 2,
                    }
                },
                {
                    id: 5,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        label: 'Update last cost',
                        name: 'UpdateLastCost'
                    }
                },
                {
                    id: 6,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        label: 'Update supplier pricing',
                        name: 'UpdateSupplierPricing'
                    }
                },
            ]
        },
    ]
};

export default ProductReceiptLineDetailsForm;
